export default "__VITE_ASSET__BQha$791__"